export function resolveDisplayAddress(home, includeZip = false) {
  if (!home) return ''
  const pick = (override, fallback) => {
    const o = (override || '').trim()
    return o || (fallback || '')
  }
  const parts = [
    pick(home.display_address, home.address),
    pick(home.display_city,    home.city),
    pick(home.display_state,   home.state),
  ]
  if (includeZip) parts.push(pick(home.display_zip, home.zip))
  return parts.filter(Boolean).join(', ')
}
